module.exports = __webpack_public_path__ + "img/building3.3c9cec1c.jpg";